import React from 'react'
import { Upload, Button } from 'antd'
import loadImage from 'blueimp-load-image'
import _get from 'lodash/get'
const signatureUri = process.env.REACT_APP_UPLOAD_SIGNATURE_URI
const MAX_DIMENSION = 2400
const MAX_THUMBNAIL_DIMENSION = 300

const resizeImg = async (file, { width, height }, quolity = 1) => {
  return new Promise((resolve, reject) => {
    loadImage(file, canvas => {
      if (canvas.type === 'error') {
        return Promise.reject(new Error('Incorrect Image'))
      }
      canvas.toBlob((blob) => {
        const result = new File([blob], file.name, {
          type: file.type,
          lastModified: Date.now()
        })
        resolve(result)
      }, file.type, 1)
    }, {
      maxWidth: width,
      maxHeight: height,
      contain: true,
      orientation: true,
      canvas: true
    })
  })
}

const gcsUpload = async (file, onProgress) => {
  const res = await fetch(`${signatureUri}?mimetype=${file.type}`, { method: 'POST' })
  const { signedUrl, fileUrl } = await res.json()
  return new Promise((resolve, reject) => {
    loadImage(file, canvas => {
      if (canvas.type === 'error') {
        return Promise.reject(new Error('Incorrect Image'))
      }
      const { width, height } = canvas
      canvas.toBlob((blob) => {
        const result = new File([blob], file.name, {
          type: file.type,
          lastModified: Date.now()
        })
        const xhr = new XMLHttpRequest()
        xhr.open('PUT', signedUrl, true)
        xhr.onprogress = ({ loaded, total }) => {
          if (onProgress) {
            onProgress({ percent: Math.round(loaded / total * 100).toFixed(2) }, file)
          }
          // console.log({ progress })
        }
        xhr.onload = (response) => {
          const status = xhr.status
          if (status === 200) {
            resolve({ url: fileUrl, size: { width, height } })
            // alert('File is uploaded')
          } else {
            reject(new Error('Something went wrong'))
            // alert('Something went wrong!')
          }
        }

        xhr.onerror = () => {
          reject(new Error('Something went wrong'))
        }
        xhr.setRequestHeader('Content-Type', file.type)
        xhr.setRequestHeader('x-goog-acl', 'public-read')
        xhr.send(result)
      }, file.type, 1)
    }, {
      orientation: true,
      canvas: true
    })
  })
}

class ImageUploader extends React.Component {
  state = {
    loading: false
  }
  handleChange = ({ file, fileList, event }) => {
    // console.log('change', { file })
    this.setState({ loading: true })
    const { onChange } = this.props
    if (file.status === 'done') {
      // const { fileUrl } = file.response
      onChange(file.response)
      this.setState({ loading: false })
    }
  }
  beforeUpload = async file => {
    // console.log('bu', { file })
  }
  customRequest = async ({
    action,
    data,
    file,
    filename,
    headers,
    onError,
    onProgress,
    onSuccess,
    withCredentials
  }) => {
    // TODO: use axios

    const [originalFile, thumbnailFile] = await Promise.all([
      resizeImg(file, { width: MAX_DIMENSION, height: MAX_DIMENSION }),
      resizeImg(file, { width: MAX_THUMBNAIL_DIMENSION, height: MAX_THUMBNAIL_DIMENSION })
    ])

    const [original, thumbnail] = await Promise.all([
      gcsUpload(originalFile, onProgress),
      gcsUpload(thumbnailFile)
    ])
    onSuccess({
      original,
      thumbnail
    })
  }
  render () {
    const { value } = this.props
    const thumbnailUrl = _get(value, 'thumbnail.url')
    return <Upload onChange={this.handleChange} beforeUpload={this.beforeUpload} customRequest={this.customRequest} showUploadList={false}>
      {value
        ? <img src={thumbnailUrl} alt="logo" style={{ width: 300 }} />
        : <Button icon="upload" loading={this.state.loading}>Upload</Button>
      }
    </Upload>
  }
}

export default ImageUploader



// WEBPACK FOOTER //
// ./src/App/components/RunImageUploader/RunImageUploader.js